import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/doctocat/doctocat/theme/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<p>{`To use images in your Doctocat site:`}</p>
<ol>
<li parentName="ol">
<p parentName="li">{`Add an `}<inlineCode parentName="p">{`images`}</inlineCode>{` folder in the root of your docs site`}</p>
</li>
<li parentName="ol">
<p parentName="li">{`Add any images you'd like to use in the `}<inlineCode parentName="p">{`images`}</inlineCode>{` folder`}</p>
</li>
<li parentName="ol">
<p parentName="li">{`In the file you'd like to use an image in, import the image using a relative path:`}</p>
</li>
</ol>
<pre><code parentName="pre" {...{}}>{`import DemoImage from '../images/demo-image.png'
`}</code></pre>
<ol {...{
      "start": 4
    }}>
<li parentName="ol">{`Then use that image name as the `}<inlineCode parentName="li">{`src`}</inlineCode>{` value in an img tag:`}</li>
</ol>
<pre><code parentName="pre" {...{}}>{`<ImageContainer>
  <img src={DemoImage} alt="a description of your image"/>
</ImageContainer>
`}</code></pre>
<p>{`Make sure to use the `}<inlineCode parentName="p">{`alt`}</inlineCode>{` attribute to describe your image for assistive technology, or use the `}<a parentName="p" {...{
        "href": "/doctocat/components/caption"
      }}><inlineCode parentName="a">{`Caption`}</inlineCode>{` component`}</a></p>
<p>{`If you run into any problems with Gatsby building the site and not being able to find your image path try the following:`}</p>
<ol>
<li parentName="ol">{`Double check that the path is correct`}</li>
<li parentName="ol">{`Try deleting the `}<inlineCode parentName="li">{`./cache`}</inlineCode>{` folder and rebuilding`}</li>
</ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      